import { userRoles } from "../shared-constants/userRoles";
import { sharedPathes } from "../shared-routing/pathe";

export function parseJwt (token) {
    try{
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));   
        return JSON.parse(jsonPayload);
    }

    catch{
        window.location.href=import.meta.env.VITE_MAIN_WEB_URL+sharedPathes.LOGIN_USERNAME
    }

 
}

export const checkRole=(token='',OnSuccess=()=>{},OnError=()=>{})=>{
    const decodeToken=parseJwt(token)
    let role:[string]=decodeToken?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? []
    if(role.includes(userRoles.INDIVIDUAL) || role.includes(userRoles.ENTERPRISE)){
        OnSuccess()
        return true
    } 
    else {
        OnError()
        return false

    }
}